import { isCloud } from '@blk/aw-env-detection';
import { conditionalParam as baseConditionalParam, ParamExclusionRule } from '../../utils/ApiUtils';
import { awPortfolioSettings } from './Base';

export const isAGraphEnabled = () => {
  // Temporarily only using AGraph APIs externally until the legacy internal ones are fixed by AGraph team
  if (isCloud()) {
    return awPortfolioSettings.getAGraphConfig?.()?.awportfolio ?? false;
  }
  return false;
};

/**
 * Default exclusion rules for AWPortfolio AGraph/Cloud APIs that reject unknown query params
 */
const AW_PORTFOLIO_PARAM_EXCLUSION_RULES: ParamExclusionRule[] = [
  {
    urlPrefix: [
      'aggregates',
      'portfolios:bulkCreate',
      'portfolios',
      'portfolios/search',
      'portfolios/user-paginate',
      'sleeve-info',
    ],
    excludedParams: ['configurationDirectory'],
  },
  {
    urlPrefix: [
      'aggregates/user-paginate',
      'portfolios/static-benchmarks',
      'portfolios/static-models',
      'portfolios/user-paginate',
      'portfolios:bulkCreate',
    ],
    excludedParams: ['viewAs'],
  },
];

/**
 * Returns the parameter value or undefined if it should be excluded for AWPortfolio endpoints
 * @param url - The API endpoint URL
 * @param paramName - The parameter name
 * @param value - The parameter value
 * @returns The value if not excluded, undefined otherwise
 */
export function conditionalParam<T>(url: string | undefined, paramName: string, value: T): T | undefined {
  return baseConditionalParam(url, paramName, value, AW_PORTFOLIO_PARAM_EXCLUSION_RULES);
}
